import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../../features/cart/reducer";
import { useNavigate } from "react-router-dom";
import Restaurant from "../../../assets/icons/reataurants.svg";
import Store from "../../../assets/icons/stores.svg";
import Supermarket from "../../../assets/icons/supermarkets.svg";

import { ReactComponent as Close } from "../../../assets/icons/close-black.svg";
import Button from "../../../components/ui/button";
import { IRootState } from "../../..";

import Authentication from "../../../utils/apiServices/authentication";
import { logout } from "../../../features/login/reducer";
import notify from "../../../utils/notify";

type PropType = {
  onClose: () => void;
};

const SideNavigation = ({ onClose }: PropType) => {
  const user = useSelector((state: IRootState) => state.user.value);

  const { loggedIn } = user;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const onHideMenu = (route?: string) => {
    setTimeout(() => {
      setMenuOpen(false);

      if (route) navigate(route);
      onClose();
    }, 300);
  };

  const onLogout = () => {
    setLoading(true);
    Authentication.logout()
      .then((res) => {
        if (res.success) {
          dispatch(logout());
          dispatch(clearCart());
          notify("success", res.message);
          localStorage.clear();
          sessionStorage.clear();
          onHideMenu();
          setLoading(false);
        } else {
          setLoading(false);
          notify("error", res.message);
        }
      })
      .catch(() => {
        setLoading(false);
        
      });
  };

  return (
    <div
      // onClick={() => {
      //   onHideMenu();
      // }}
      className="bg-lightBlack z-[20] fixed top-0 left-0 right-0 bottom-0 transition-all ease-in-out delay-150"
    >
      <div
        className="fixed top-0 bottom-0 left-0 w-[20%] z-[19]"
        onClick={onClose}
      ></div>
      <div className="flex flex-col justify-between w-[80%] nav bg-[#FFFCF9] fixed top-0 bottom-0 right-0  z-[19] ">
        <div className="">
          <div className="border-b flex justify-end px-3 w-full py-5">
            <Close
              stroke="black"
              fill="black"
              className=""
              onClick={() => onHideMenu()}
            />
          </div>
          <div className="flex flex-col px-8 gap-6 py-4">
            <div className="text-base font-medium capitalize text-greyB">
              Establishments
            </div>
            <div
              className="flex items-center gap-3"
              onClick={() => onHideMenu("/restaurant")}
            >
              <img src={Restaurant} alt="" />
              <div className="text-sm font-medium">Restaurants</div>
            </div>{" "}
            <div
              className="flex items-center gap-3"
              onClick={() => onHideMenu("/supermarket")}
            >
              <img src={Supermarket} alt="" />
              <div className="text-sm font-medium">Supermarket</div>
            </div>{" "}
            <div
              className="flex items-center gap-3"
              onClick={() => onHideMenu("/store")}
            >
              <img src={Store} alt="" />
              <div className="text-sm font-medium">Store</div>
            </div>
          </div>
        </div>
        {loggedIn ? (
          <div className="px-3 mb-4">
            <Button
              label="Logout"
              loading={loading}
              onClick={onLogout}
              color="wine"
            />
          </div>
        ) : (
          <div className="flex flex-col gap-3 px-3 mb-4">
            <Button
              label="Sign in"
              loading={false}
              onClick={() => onHideMenu("/login")}
            />
            <Button
              label="Sign up"
              loading={false}
              onClick={() => onHideMenu("/signup")}
              color="orange"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SideNavigation;
